import { Bell, Briefcase, Grid, Heart, LogIn, LogOut, MessageCircle, Money, Share2, Shield, ShoppingBag, Sliders, User, Wallet, Shop, ConfiguracaoDeServico, } from '../components/Icons';
import { getABTest } from './';
const marketplaceNameVariant = () => getABTest('autos-marketplace-header_enabled');
export default (publicAccountId, isAB = false) => {
    const loggedOutUserLinks = [
        {
            title: 'Entrar',
            href: 'https://conta.olx.com.br/anuncios',
            Icon: LogIn,
            objectDetail: 'login',
        },
        {
            title: 'Chat',
            href: 'https://conta.olx.com.br/chats',
            Icon: MessageCircle,
            objectDetail: 'chat',
            divider: true,
        },
        {
            title: 'Meus anúncios',
            href: 'https://conta.olx.com.br/anuncios',
            Icon: Grid,
            objectDetail: 'my_ads',
        },
        {
            title: 'Minhas vendas',
            href: 'https://meus-pedidos.olx.com.br/minhas-vendas',
            Icon: Shop,
            objectDetail: 'olx_pay_seller_orders',
        },
        {
            title: 'Plano profissional',
            href: 'https://planoprofissional.olx.com.br/',
            Icon: Briefcase,
            objectDetail: 'my_plan',
            divider: true,
        },
        {
            title: 'Minhas compras',
            href: 'https://meus-pedidos.olx.com.br/minhas-compras',
            Icon: ShoppingBag,
            objectDetail: 'olx_pay_buyer_orders',
        },
    ];
    const abLoggedOutUserLinks = [
        {
            title: 'Entrar',
            href: 'https://conta.olx.com.br/anuncios',
            Icon: LogIn,
            objectDetail: 'login',
        },
        {
            title: 'Chat',
            href: 'https://conta.olx.com.br/chats',
            Icon: MessageCircle,
            objectDetail: 'chat',
            divider: true,
        },
        {
            title: 'Meus anúncios',
            href: 'https://conta.olx.com.br/anuncios',
            Icon: Grid,
            objectDetail: 'my_ads',
        },
        {
            title: 'Minhas vendas',
            href: 'https://meus-pedidos.olx.com.br/minhas-vendas',
            Icon: Shop,
            objectDetail: 'olx_pay_seller_orders',
            divider: true,
        },
        {
            title: 'Minhas compras',
            href: 'https://meus-pedidos.olx.com.br/minhas-compras',
            Icon: ShoppingBag,
            objectDetail: 'olx_pay_buyer_orders',
        },
    ];
    const authenticatedUserLinks = [
        {
            title: 'Meu cadastro',
            href: 'https://www3.olx.com.br/account/form_userinfo',
            Icon: User,
            divider: true,
            objectDetail: 'conta',
        },
        {
            title: 'Banner',
            href: 'https://www.olx.com.br/tabela-fipe',
            Icon: User,
            objectDetail: 'banner',
        },
        {
            title: 'Notificações',
            divider: !isAB,
            href: 'https://conta.olx.com.br/notificacoes/',
            Icon: Bell,
            objectDetail: 'notification',
        },
        {
            title: 'Chat',
            divider: true,
            href: 'https://conta.olx.com.br/chats',
            Icon: MessageCircle,
            objectDetail: 'chat',
        },
        {
            title: 'Meus anúncios',
            href: 'https://conta.olx.com.br/anuncios',
            Icon: Grid,
            objectDetail: 'my_ads',
        },
        {
            title: 'Minhas vendas',
            href: 'https://meus-pedidos.olx.com.br/minhas-vendas',
            Icon: Shop,
            objectDetail: 'olx_pay_seller_orders',
        },
        {
            title: 'Carteira OLX Pay',
            href: 'https://wallet.olx.com.br/',
            Icon: Wallet,
            objectDetail: 'wallet',
        },
        {
            title: 'Plano profissional',
            href: 'https://planoprofissional.olx.com.br/',
            Icon: Briefcase,
            objectDetail: 'my_plan',
        },
        {
            title: marketplaceNameVariant() ? 'OLX Acelera Autos' : 'Serviços Automotivos OLX',
            href: 'https://autos-marketplace.olx.com.br/',
            Icon: ConfiguracaoDeServico,
            objectDetail: 'autos_marketplace',
        },
        {
            title: 'Meu perfil público',
            divider: true,
            href: `https://www.olx.com.br/perfil/${publicAccountId}`,
            Icon: Share2,
            objectDetail: 'profile_page',
        },
        {
            title: 'Minhas compras',
            href: 'https://meus-pedidos.olx.com.br/minhas-compras',
            Icon: ShoppingBag,
            objectDetail: 'olx_pay_buyer_orders',
        },
        {
            title: 'Favoritos',
            divider: true,
            href: 'https://www3.olx.com.br/account/favorites',
            Icon: Heart,
            objectDetail: 'favorite_ads',
        },
        {
            title: 'Segurança e privacidade',
            href: 'https://conta.olx.com.br/seguranca',
            Icon: Shield,
            objectDetail: 'security_central',
        },
        {
            title: 'Configuração de comunicações',
            href: 'https://conta.olx.com.br/comunicacoes',
            Icon: Sliders,
            objectDetail: 'communication',
        },
        {
            title: 'Gerenciar Pagamentos',
            href: 'https://conta.olx.com.br/pagamentos',
            Icon: Money,
            objectDetail: 'payment_central',
        },
        {
            title: 'Sair',
            href: 'https://www3.olx.com.br/account/do_logout',
            Icon: LogOut,
            objectDetail: 'logout',
        },
    ];
    if (isAB && !publicAccountId)
        return abLoggedOutUserLinks;
    return !publicAccountId ? loggedOutUserLinks : authenticatedUserLinks;
};
